import request from './request'

export function listWorkCalendar(data) {
  return request.post('/mes/work-calendars/list', data)
}
export function selectWorkCalendar() {
  return request.get('/mes/work-calendars/select')
}
export function getWorkCalendar(id) {
  return request.get('/mes/work-calendars/' + id)
}
export function saveWorkCalendar(data) {
  return request.post('/mes/work-calendars', data)
}
export function updateWorkCalendar(data) {
  return request.post('/mes/work-calendars/update', data)
}
export function deleteWorkCalendar(ids) {
  return request.post('/mes/work-calendars/delete', ids)
}
export function shiftsForDate(params) {
  return request.get('/mes/work-calendars/shifts-for-date', { params })
}
export function isWorkingDay(params) {
  return request.get('/mes/work-calendars/is-working-day', { params })
}
